export default "__VITE_ASSET__B2KQR7Zt__"